import React from 'react';
import { Box, Typography, ListItemButton } from '@mui/material';
import { PiPicnicTableLight } from 'react-icons/pi';
import { FaCheck } from 'react-icons/fa6';

const FloorPlanSelector = ({
  floorPlans,
  selectedFloor,
  onSelectFloor,
  currentColor,
  IS_TERRACE,
  isLoading,
  photos,
}) => {
  return (
    <Box
      sx={{
        mt: 1,
        display: 'flex',
        gap: 1.5,
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      {floorPlans?.map((floor, index) => {
        const selected = selectedFloor === floor?.Id;
        const image = photos?.[index]?.Link || photos?.[0]?.Link;

        return (
          <ListItemButton
            key={floor?.Id || index}
            onClick={() => onSelectFloor(floor?.Id)}
            selected={selected}
            disabled={Boolean(isLoading && floor?.Id !== selectedFloor)}
            sx={{
              position: 'relative',
              overflow: 'hidden',
              width: {
                xs: '100%',
                sm: floorPlans?.length === 1 ? '100%' : 'calc(50% - 6px)',
              },
              minHeight: 150,
              alignItems: 'flex-end',
              justifyContent: 'flex-start',
              border: '2px solid transparent',
              borderColor: selected ? currentColor.primary : 'transparent',
              borderRadius: '14px',
              p: 1.2,
              background: image
                ? `linear-gradient(180deg, rgba(0,0,0,0.08), rgba(0,0,0,0.78)), url('${image}')`
                : 'linear-gradient(135deg, #3f3f46, #111827)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              color: '#fff',
              '&.Mui-selected': {
                borderColor: currentColor.primary,
                bgcolor: 'transparent',
              },
              '&.Mui-disabled': {
                opacity: 0.55,
              },
            }}
          >
            {selected && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 10,
                  right: 10,
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  bgcolor: currentColor.primary,
                  display: 'grid',
                  placeItems: 'center',
                }}
              >
                <FaCheck
                  style={{
                    fontSize: '12px',
                    color:
                      selected && IS_TERRACE
                        ? '#013709'
                        : currentColor.onPrimary ?? '#fff',
                  }}
                />
              </Box>
            )}
            <Box sx={{ position: 'relative', zIndex: 1 }}>
              <PiPicnicTableLight
                style={{
                  fontSize: '18px',
                  color: selected && IS_TERRACE ? '#013709' : '#fff',
                }}
              />
              <Typography sx={{ fontWeight: 900, fontSize: '14px', mt: 0.2 }}>
                {floor?.Name}
              </Typography>
              <Typography sx={{ fontSize: '11px', color: '#f1f1f1' }}>
                {index === 0 ? '' : ''}
              </Typography>
            </Box>
          </ListItemButton>
        );
      })}
    </Box>
  );
};

export default FloorPlanSelector;
